
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Jeder fünfte Mensch mit Migräne hegt den Verdacht, dass die Attacken durch
bestimmte Nahrungsmittel verursacht werden. In einer kleinen türkischen Studie
haben Forscher im Blut von 30 Personen nach Abwehrstoffen (Antikörpern) gegen
Nahrungsmittel gesucht. Am häufigsten fanden sie Antikörper gegen Gewürze, Nüsse
und Samen, Meerestiere und gegen Stärke. Als die Versuchspersonen diejenigen
Nahrungsmittel strichen, gegen die sie Antikörper hatten, sank die Zahl der
Kopfschmerztage von durchschnittlich 10,5 auf 7,5 und die Migräneattacken von 9
auf 6,2. Für einen Beweis genügt diese Studie aber noch lange nicht, zumal
verschiedene Fachleute stark an ihren Ergebnissen zweifeln. Wer vermutet, dass
bestimmte Lebensmittel für die Migräne verantwortlich sind, sollte ein
Ernährungstagebuch führen. Das kann hilfreich sein, um Genaueres herauszufinden.
Bioresonanz ist übrigens nicht geeignet, um sicher festzustellen, was ein Mensch
verträgt und was nicht.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;